import clsx from 'clsx';
import { type HTMLAttributes, forwardRef } from 'react';

export type StackGap = 1 | 2 | 3 | 4 | 6 | 8 | 12 | 16;

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  gap?: StackGap;
}

export const Stack = forwardRef<HTMLDivElement, StackProps>(function Stack(
  { gap = 4, className, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={clsx('perch-stack', className)} data-gap={String(gap)} {...rest} />
  );
});

export const Row = forwardRef<HTMLDivElement, StackProps>(function Row(
  { gap = 3, className, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={clsx('perch-row', className)} data-gap={String(gap)} {...rest} />
  );
});
